var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.9986,
    height: 19.9986,
    rx: 9.99931,
    fill: "#FFF6E5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99931 0C4.47684 0 0 4.47684 0 9.99931C0 10.1332 0.00263315 10.2666 0.0078505 10.3992C0.217762 5.06213 4.61078 0.799805 9.99931 0.799805C15.3878 0.799805 19.7809 5.06213 19.9908 10.3992C19.996 10.2666 19.9986 10.1332 19.9986 9.99931C19.9986 4.47684 15.5218 0 9.99931 0Z",
    fill: "#CACACA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 19.9985C15.5224 19.9985 19.9993 15.5217 19.9993 9.99923C19.9993 9.86529 19.9966 9.73198 19.9914 9.59932C19.7815 14.9364 15.3885 19.1987 9.99996 19.1987C4.61143 19.1987 0.218413 14.9364 0.00850196 9.59932C0.00328535 9.73198 0.000651292 9.86529 0.00065128 9.99922C0.000650797 15.5217 4.47749 19.9985 9.99996 19.9985Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91459 4.60245V7.00242H5.92401C5.84002 7.00277 5.75681 6.98627 5.6793 6.95392C5.60179 6.92157 5.53154 6.87401 5.47272 6.81405C5.41389 6.7541 5.36767 6.68296 5.33678 6.60484C5.3059 6.52673 5.29098 6.44321 5.2929 6.35923V4.64085C5.29179 4.62807 5.29179 4.61522 5.2929 4.60245H9.91459Z",
    fill: "#FDCD08"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.533 4.6024H5.29207C5.29829 4.44005 5.36734 4.28647 5.48464 4.17407C5.60195 4.06168 5.75833 3.99926 5.92077 4.00001H13.9163C14.0769 4.00176 14.2306 4.06535 14.3454 4.17755C14.4603 4.28975 14.5275 4.44192 14.533 4.6024Z",
    fill: "#F8EC30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5348 4.6412V6.35959C14.5364 6.44236 14.5216 6.52464 14.4913 6.60169C14.461 6.67874 14.4158 6.74906 14.3583 6.8086C14.3008 6.86813 14.2321 6.91572 14.1561 6.94863C14.0802 6.98155 13.9985 6.99913 13.9157 7.00038H9.91071V4.6004H14.5324C14.5345 4.6139 14.5353 4.62756 14.5348 4.6412Z",
    fill: "#F58A1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60826 4.46094H5.97707V6.53932H6.60826V4.46094Z",
    fill: "#FCEE3B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8183 4.46094H7.1871V6.53932H7.8183V4.46094Z",
    fill: "#FCEE3B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02012 4.46094H8.38893V6.53932H9.02012V4.46094Z",
    fill: "#FCEE3B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2261 4.46094H9.59486V6.53932H10.2261V4.46094Z",
    fill: "#FCEE3B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4361 4.46094H10.8049V6.53932H11.4361V4.46094Z",
    fill: "#FCEE3B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.642 4.46094H12.0108V6.53932H12.642V4.46094Z",
    fill: "#FCEE3B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8479 4.46094H13.2168V6.53932H13.8479V4.46094Z",
    fill: "#FCEE3B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91323 7.59933V9.99931H5.92265C5.83968 9.99838 5.75771 9.98102 5.68147 9.94825C5.60524 9.91548 5.53624 9.86794 5.47846 9.80837C5.42069 9.7488 5.37527 9.67838 5.34484 9.60117C5.31441 9.52396 5.29956 9.44149 5.30115 9.35852V7.64253C5.29999 7.62896 5.29999 7.61531 5.30115 7.60173L9.91323 7.59933Z",
    fill: "#FDCD08"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.533 7.59945H5.29207C5.2989 7.43752 5.36821 7.28455 5.48545 7.17266C5.60269 7.06078 5.75872 6.99869 5.92077 6.99946H13.9163C14.0765 7.00119 14.2298 7.06445 14.3446 7.17614C14.4594 7.28782 14.5269 7.43939 14.533 7.59945Z",
    fill: "#F8EC30"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5348 7.64253V9.35852C14.5364 9.44129 14.5216 9.52357 14.4913 9.60062C14.461 9.67768 14.4158 9.74799 14.3583 9.80753C14.3008 9.86706 14.2321 9.91465 14.1561 9.94757C14.0802 9.98048 13.9985 9.99806 13.9157 9.99931H9.91071V7.59933H14.5324C14.5345 7.61363 14.5353 7.62809 14.5348 7.64253Z",
    fill: "#F58A1F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60826 7.46091H5.97707V9.53929H6.60826V7.46091Z",
    fill: "#FCEE3B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8183 7.46091H7.1871V9.53929H7.8183V7.46091Z",
    fill: "#FCEE3B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02012 7.46091H8.38893V9.53929H9.02012V7.46091Z",
    fill: "#FCEE3B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2261 7.46091H9.59486V9.53929H10.2261V7.46091Z",
    fill: "#FCEE3B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4361 7.46091H10.8049V9.53929H11.4361V7.46091Z",
    fill: "#FCEE3B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.642 7.46091H12.0108V9.53929H12.642V7.46091Z",
    fill: "#FCEE3B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8479 7.46091H13.2168V9.53929H13.8479V7.46091Z",
    fill: "#FCEE3B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62255 10.5998V12.9998H4.61997C4.53709 12.9982 4.45533 12.9803 4.37936 12.9472C4.30338 12.914 4.23469 12.8662 4.1772 12.8064C4.1197 12.7467 4.07454 12.6762 4.04429 12.5991C4.01403 12.5219 3.99928 12.4395 4.00087 12.3566V10.6406C3.99971 10.627 3.99971 10.6134 4.00087 10.5998H8.62255Z",
    fill: "#FDCD08"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2434 10.5999H4C4.00617 10.4394 4.07397 10.2875 4.18928 10.1758C4.30459 10.064 4.45854 10.001 4.6191 9.99991H12.6387C12.7967 10.0047 12.9471 10.0693 13.0593 10.1806C13.1716 10.292 13.2374 10.4419 13.2434 10.5999Z",
    fill: "#F8EC30"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2468 10.6406V12.3566C13.2501 12.522 13.1883 12.682 13.0748 12.8023C12.9612 12.9226 12.805 12.9935 12.6397 12.9998H8.62274V10.5998H13.2444C13.2464 10.6133 13.2472 10.6269 13.2468 10.6406Z",
    fill: "#F58A1F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3203 10.4604H4.6891V12.5387H5.3203V10.4604Z",
    fill: "#FCEE3B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52623 10.4604H5.89503V12.5387H6.52623V10.4604Z",
    fill: "#FCEE3B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73216 10.4604H7.10097V12.5387H7.73216V10.4604Z",
    fill: "#FCEE3B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9422 10.4604H8.311V12.5387H8.9422V10.4604Z",
    fill: "#FCEE3B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M10.144 10.4604H9.51283V12.5387H10.144V10.4604Z",
    fill: "#FCEE3B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.354 10.4604H10.7229V12.5387H11.354V10.4604Z",
    fill: "#FCEE3B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12.56 10.4604H11.9288V12.5387H12.56V10.4604Z",
    fill: "#FCEE3B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3749 13.6003V16.0003H7.37228C7.20531 15.9971 7.0464 15.9279 6.93036 15.8078C6.81432 15.6877 6.7506 15.5265 6.75317 15.3595V13.6411C6.75201 13.6275 6.75201 13.6139 6.75317 13.6003H11.3749Z",
    fill: "#FDCD08"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 13.6004H6.75641C6.76198 13.4401 6.82925 13.2882 6.94418 13.1764C7.0591 13.0646 7.21279 13.0015 7.37311 13.0004H15.3807C15.5412 13.0015 15.6952 13.0645 15.8105 13.1763C15.9258 13.288 15.9936 13.4399 15.9998 13.6004Z",
    fill: "#F8EC30"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9991 13.6411V15.3595C16.0017 15.5265 15.938 15.6877 15.8219 15.8078C15.7059 15.9279 15.547 15.9971 15.38 16.0003H11.375V13.6003H15.9991C16.0003 13.6139 16.0003 13.6275 15.9991 13.6411Z",
    fill: "#F58A1F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06851 13.4608H7.43732V15.5392H8.06851V13.4608Z",
    fill: "#FCEE3B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27853 13.4608H8.64734V15.5392H9.27853V13.4608Z",
    fill: "#FCEE3B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4845 13.4608H9.85327V15.5392H10.4845V13.4608Z",
    fill: "#FCEE3B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6904 13.4608H11.0592V15.5392H11.6904V13.4608Z",
    fill: "#FCEE3B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9004 13.4608H12.2692V15.5392H12.9004V13.4608Z",
    fill: "#FCEE3B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1023 13.4608H13.4711V15.5392H14.1023V13.4608Z",
    fill: "#FCEE3B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3123 13.4608H14.6811V15.5392H15.3123V13.4608Z",
    fill: "#FCEE3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashIcon);
export default __webpack_public_path__ + "static/media/cash_icon.ce5e44c9643e5212b6474d4ea2d2fb1a.svg";
export { ForwardRef as ReactComponent };